/* eslint-disable max-len, no-param-reassign, no-unused-vars */
/**
 * Air theme JavaScript.
 */

// Import modules
import {
  styleExternalLinks,
  initExternalLinkLabels,
} from './modules/external-link';
import initAnchors from './modules/anchors';
import backToTop from './modules/top';
import initA11ySkipLink from './modules/a11y-skip-link';
import initA11yFocusSearchField from './modules/a11y-focus-search-field';
import {
  navSticky,
  navClick,
  navDesktop,
  navMobile,
} from './modules/navigation';
import initDesignSystem from './modules/design-system';
import initStickyHeader from './modules/sticky-header';
import initTabs from './modules/tabs';
import initProductGallery from './modules/product-gallery';
import initGalleryStripVideoFallback from './modules/gallery-strip-video-fallback';
import initFaqImageSync from './modules/faq-image-sync';
import initAccordion from './modules/accordion';
import initCartDrawer from './modules/cart-drawer';
import initIframeModal from './modules/iframe-modal';
import initPaginaInformativaToc from './modules/pagina-informativa';
import initShopFilters from './modules/shop-filters';
import initWhatsappFloatBubble from './modules/whatsapp-float-bubble';
import initThankYou from './modules/thank-you';
import initCookieNotice from './modules/cookie-notice';
import initTestimonials from './modules/home';
import initServicioGallery from './modules/servicio-gallery';
import initMymReveal from './modules/mym-reveal';
// Define Javascript is active by changing the body class
document.body.classList.remove('no-js');
document.body.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  initAnchors();
  backToTop();
  styleExternalLinks();
  initExternalLinkLabels();
  initA11ySkipLink();
  initA11yFocusSearchField();

  // Init navigation
  // If you want to enable click based navigation, comment navDesktop() and uncomment navClick()
  // Remember to enable styles in assets/src/sass/navigation/navigation.scss
  navDesktop();
  // navClick();
  navMobile();

  initDesignSystem();
  initStickyHeader();
  initTabs();
  initProductGallery();
  initGalleryStripVideoFallback();
  initFaqImageSync();
  initAccordion();
  initCartDrawer();
  initIframeModal();
  initPaginaInformativaToc();
  initShopFilters();
  initWhatsappFloatBubble();
  initThankYou();
  initCookieNotice();
  initTestimonials();
  initServicioGallery();
  initMymReveal();

  // Uncomment if you like to use a sticky navigation
  // navSticky();
});
